export { default } from './PrismPartsCount';
